import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import {
  BannerContentTypography,
  NonEngContentWrapper,
  RotatingNonEngContent,
} from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/BottomSignUpBannerStyles";
import {
  KEYWORDS,
  getURLFromKeyword,
} from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/consts";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import React, { type JSX } from "react";

const getProductLink = (chunks: React.ReactNode, linkTo: string) => {
  return (
    <Button
      variant="tertiary"
      linkTo={linkTo}
      style={{ textDecorationThickness: "0.1em" }}
      onClick={() => {
        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
          "perfect_product_banner-product-link",
          linkTo
        );
      }}
    >
      <BannerContentTypography style={{ color: "unset" }}>
        {chunks}
      </BannerContentTypography>
    </Button>
  );
};
export const NonEnglishContent: React.FC = () => {
  const routingContext = useRetailerRoutingContext();
  return (
    <NonEngContentWrapper data-test-id="non-english-content-wrapper">
      <RotatingNonEngContent index={0}>
        <StrictLocalMsg
          defaultMessage="The Perfect <ProductLinkFormatting>drinkware</ProductLinkFormatting> for your store, right this way."
          description={{
            text: "This is the banner content for the bottom sign up banner",
          }}
          values={{
            ProductLinkFormatting: (chunks: JSX.Element) =>
              getProductLink(
                chunks,
                getURLFromKeyword(KEYWORDS.DRINKWARE, routingContext)
              ),
          }}
        />
      </RotatingNonEngContent>
      <RotatingNonEngContent index={1}>
        <StrictLocalMsg
          defaultMessage="The Perfect <ProductLinkFormatting>planter</ProductLinkFormatting> for your store, right this way."
          description={{
            text: "This is the banner content for the bottom sign up banner",
          }}
          values={{
            ProductLinkFormatting: (chunks: JSX.Element) =>
              getProductLink(
                chunks,
                getURLFromKeyword(KEYWORDS.PLANTER, routingContext)
              ),
          }}
        />
      </RotatingNonEngContent>
      <RotatingNonEngContent index={2}>
        <StrictLocalMsg
          defaultMessage="The Perfect <ProductLinkFormatting>moisturizer</ProductLinkFormatting> for your store, right this way."
          description={{
            text: "This is the banner content for the bottom sign up banner",
          }}
          values={{
            ProductLinkFormatting: (chunks: JSX.Element) =>
              getProductLink(
                chunks,
                getURLFromKeyword(KEYWORDS.MOISTURIZER, routingContext)
              ),
          }}
        />
      </RotatingNonEngContent>
      <RotatingNonEngContent index={3}>
        <StrictLocalMsg
          defaultMessage="The Perfect <ProductLinkFormatting>coffee</ProductLinkFormatting> for your store, right this way."
          description={{
            text: "This is the banner content for the bottom sign up banner",
          }}
          values={{
            ProductLinkFormatting: (chunks: JSX.Element) =>
              getProductLink(
                chunks,
                getURLFromKeyword(KEYWORDS.COFFEE, routingContext)
              ),
          }}
        />
      </RotatingNonEngContent>
      <RotatingNonEngContent index={4}>
        <StrictLocalMsg
          defaultMessage="The Perfect <ProductLinkFormatting>candle</ProductLinkFormatting> for your store, right this way."
          description={{
            text: "This is the banner content for the bottom sign up banner",
          }}
          values={{
            ProductLinkFormatting: (chunks: JSX.Element) =>
              getProductLink(
                chunks,
                getURLFromKeyword(KEYWORDS.CANDLE, routingContext)
              ),
          }}
        />
      </RotatingNonEngContent>
    </NonEngContentWrapper>
  );
};
